/**
 * Returns true if today is Monday (1) or Tuesday (2) in local time.
 * The insights banner is only shown on these days.
 */
export const isInsightsScheduledDay = (date: Date = new Date()): boolean => {
	const day = date.getDay();
	return day === 1 || day === 2; // 1 = Monday, 2 = Tuesday
};
